import { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from 'react-router-dom'
import Home from './pages/Home/Home'
import OurTeam from './pages/OurTeam/OurTeam'
import GetInTouch from './pages/GetInTouch/GetInTouch'
import Newsletter from './pages/Newsletter/Newsletter'
import FAQ from './pages/FAQ/FAQ'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import { deleteSession } from './utils'
import ReciprocityMap from './pages/ReciprocityMap/ReciprocityMap'
import ReciprocityNations from './pages/ReciprocityNations/ReciprocityNations'
import HowRWorks from './pages/HowRWorks/HowRWorks'
import WhatIsReciprocity from './pages/WhatIsReciprocity/WhatIsReciprocity'
import ImSomethingElse from './pages/ImSomethingElse/ImSomethingElse'
import ImABusinessOwner from './pages/ImABusinessOwner/ImABusinessOwner'
import ImARenter from './pages/ImARenter/ImARenter'
import ImAHomeowner from './pages/ImAHomeowner/ImAHomeowner'
import ImIndigenous from './pages/ImIndigenous/ImIndigenous'
import ImANonProfit from './pages/ImANonProfit/ImANonProfit'
import BackyardRestoration from './pages/BackyardRestoration/BackyardRestoration'
import ActsOfReciprocity from './pages/ActsOfReciprocity/ActsOfReciprocity'
import geoDataCache from './utils/geoDataCache'
import styles from './App.module.css'

function AppContent() {
  const location = useLocation();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isMapSubdomain = hostname.startsWith('map.');
  const isMapPage = location.pathname === '/reciprocity-map' || (isMapSubdomain && location.pathname === '/');

  useEffect(() => {
    deleteSession();
    
    // Preload GeoJSON files for address lookup
    const preload = async () => {
      try {
        await geoDataCache.preload();
      } catch (error) {
        console.error('Failed to preload geographic data:', error);
      }
    };
    preload();
  }, []);

  return (
    <div style={{ display: 'flex', 'minHeight': '100vh', 'flexDirection': 'column' }}>
      {!isMapPage && <Header />}
      <ScrollToTop >
        <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }} className={`${!isMapPage ? styles.body : ''}`}>
          <Routes>
            <Route path='/our-team' element={<OurTeam />} />
            <Route path='/newsletter' element={<Newsletter />} />
            <Route path='/faq' element={<FAQ />} />
            <Route path='/get-in-touch' element={<GetInTouch />} />
            <Route path='/reciprocity-map' element={<ReciprocityMap />} />
            <Route path='/reciprocity-nations' element={<ReciprocityNations />} />
            <Route path='/how-r-works' element={<HowRWorks />} />
            <Route path='/what-is-reciprocity' element={<WhatIsReciprocity />} />
            <Route path='/backyard-restoration' element={<BackyardRestoration />} />
            <Route path='/acts-of-reciprocity' element={<ActsOfReciprocity />} />
            <Route path='/im-something-else' element={<ImSomethingElse />} />
            <Route path='/im-a-non-profit' element={<ImANonProfit />} />
            <Route path='/im-indigenous' element={<ImIndigenous />} />
            <Route path='/im-a-business-owner' element={<ImABusinessOwner />} />
            <Route path='/im-a-renter' element={<ImARenter />} />
            <Route path='/im-a-homeowner' element={<ImAHomeowner />} />
            <Route path='/thankyou' element={<Home thankyou />} />
            <Route path='/' element={isMapSubdomain ? <ReciprocityMap /> : <Home />} />
          </Routes>
        </div>
      </ScrollToTop>
      {!isMapPage && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppContent />
    </Router>
  );
}
